export default __webpack_public_path__ + "94d9cf5b1e85ad3f5538c0d9282cf531.png";